import {Moment} from 'moment';
import {useParams} from 'react-router-dom';
import {DateRangeType} from '../../../date-range-input/date-range-utils';
import {CareServicesBody} from '../../base/body/care-services-body';
import {CareServicesCalendar} from '../../base/body/care-services-calendar';
import {
  OnCareServiceCreatingItem,
  OnCareServiceEditItem,
  OnCareServiceClickItem,
} from '../../base/data/care-service-item';
import {CareServicesData} from '../../base/data/use-care-services-data';

interface SeniorCareServicesBodyProps {
  data: CareServicesData;
  range: DateRangeType;
  date: Moment;
  canWrite?: boolean;
  onClickItem: OnCareServiceClickItem;
  onCreatingItem: OnCareServiceCreatingItem;
  onEditItem: OnCareServiceEditItem;
}

export function SeniorCareServicesBody(props: SeniorCareServicesBodyProps) {
  const {id}: {url: string; entityId: string; id: string} = useParams();

  return (
    <CareServicesBody isLoading={props.data.fetching}>
      {/* --------- CALENDAR --------- */}
      <CareServicesCalendar
        data={props.data}
        range={props.range}
        date={props.date}
        canWrite={props.canWrite}
        onClickItem={props.onClickItem}
        onCreatingItem={(item) => {
          // --- additional fields ---
          // add targetUserId as the current senior id
          item.targetUserId = id;

          props.onCreatingItem(item);
        }}
        onEditItem={props.onEditItem}
      />
    </CareServicesBody>
  );
}
